function submitLiquidForm(clicker, success = null, failed = null) {
  const form = getParentForm(clicker);
  console.log(form.action);
  console.log(form.method);

  if (!form) return false;

  // Update phone numbers with full international format before validation
  // Note: Appointment form now has its own handler, this is for other forms
  if (window.updatePhoneNumbers) {
    window.updatePhoneNumbers();
  }

  const checkFields = Senitize(form);
  const method = form.method;
  const action = form.action;
  if (!checkFields) return;

  const formData = new FormData(form);

  fetch(action, {
    method: method || "GET",
    body: formData,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    },
  }).then((response) => {
    if (!response.ok) {
      return (failed.style.display = "block");
    }
    return (success.style.display = "block");
  });
}

function Senitize(form) {
  let isValid = true;

  const requiredInputs = Array.from(
    form.querySelectorAll(
      "input[required], textarea[required], select[required]"
    )
  ).reverse();

  for (const input of requiredInputs) {
    if (!input.value.trim()) {
      input.reportValidity();
      isValid = false;
    }
  }

  return isValid;
}

function getParentForm(childElement) {
  let currentElement = childElement;

  while (currentElement) {
    if (currentElement.tagName.toLowerCase() === "form") {
      return currentElement;
    }

    currentElement = currentElement.parentElement;
  }

  return null;
}
